<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="140px">
      <el-form-item label="公司名称" prop="corporateName" v-if="!dataForm.id">
          <el-input v-model="dataForm.corporateName" placeholder="公司名称"></el-input>
      </el-form-item>
      <el-form-item prop="legalRepresentative" label="法定代表人">
        <el-input v-model="dataForm.legalRepresentative" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item prop="dwellingPlace" label="住所">
        <el-input v-model="dataForm.dwellingPlace" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item prop="creditorRight" label="债权受让方联系人">
        <el-input v-model="dataForm.creditorRight" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item prop="creditorTelephone"  label="债权受让方电话">
        <el-input  v-model="dataForm.creditorTelephone" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { cron } from 'vue-cron'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        corporateName:'',
        legalRepresentative: '',
        dwellingPlace: '',
        creditorRight: '',
        creditorTelephone: ''
      },
      cronPopover: false
    }
  },
  components: {
    cron
  },
  computed: {
    dataRule () {
      return {
      
        legalRepresentative: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        
        dwellingPlace: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creditorRight: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creditorTelephone: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { required: true, pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的电话', trigger: 'change' }
        ],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    changeCron (val) {
      this.dataForm.cronExpression = val
    },
    // 获取信息
    getInfo () {
      this.$http.post(`/loan/transfer/signMessageReturn`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = res.data
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post('/loan/transfer/signMessage', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.$emit('getPerfectInfo')
              this.visible = false
              
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
